import useSWR from 'swr';
import { useIntl } from 'react-intl';

import { useSession } from '@packages/utilities';
import { addBranchToOrderUrlPath } from '../../../../helpers/addBranchToOrderUrlPath';
import type { BasketResponse } from '../types';

// TODO(api-layer): delete unnecessary fetcher and use generated types after resolver are available in api-layer
const fetcher =
  (locale: string) =>
  ([url, token]: [string, string]): Promise<BasketResponse> =>
    fetch(url, { headers: { 'x-ec-token': token, 'ec-locale': locale } }).then((res) => {
      if (!res.ok) {
        throw new Error(`Error fetching basket data: ${res.status} ${res.statusText}`);
      }
      return res.json();
    });

export const useBasketData = (lineItemId: string | null) => {
  const { jwtToken } = useSession();
  const { locale } = useIntl();
  const { data } = useSWR(
    jwtToken && lineItemId
      ? [addBranchToOrderUrlPath('/api/checkout/v1/'), jwtToken, lineItemId]
      : null,
    fetcher(locale),
    {
      suspense: true,
    },
  );
  return { data };
};
